// removed by extract-text-webpack-plugin
module.exports = {"navBar":"NavBar__navBar___16bj1","button":"NavBar__button___24kqU","regenerate":"NavBar__regenerate___3laXo","rotate":"NavBar__rotate___5oO92","loading":"NavBar__loading___2BEYS","levels":"NavBar__levels___30l4v","bounceIn":"NavBar__bounceIn___1YPWL","prizes":"NavBar__prizes___2eC8J","badge":"NavBar__badge___2DBaM","settings":"NavBar__settings___mUXRA","active":"NavBar__active___3IudD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/NavBar.css
// module id = 863
// module chunks = 0